import { render, staticRenderFns } from "./ProductListPage.vue?vue&type=template&id=3463ba52&scoped=true&"
import script from "./ProductListPage.vue?vue&type=script&lang=js&"
export * from "./ProductListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductListPage.vue?vue&type=style&index=0&id=3463ba52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3463ba52",
  null
  
)

export default component.exports